/**
 * This component is now deprecated - the goal with this component was to create a form input of a particular type
 * and simulate input validation on that input.  Use of the InputField component that is wrapped by the WithValidation
 * component is preferred.
 */
import React, { Component, ReactDOM } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { HelpBlock } from 'react-bootstrap';
import {InputContainer} from 'react-spark';
import Label from '../rl-conditional-label/RlConditionalLabel';

class InputFieldDeprecated extends Component {
    constructor(props) {
        super(props);

        // Flag for whether or not blur event has been triggered, to be used in the onChange handler
        this.hasBlurFired = false;
        this.updateErrorState = this.props.updateErrorState || _.noop;
        this.updateValueState = this.props.updateValueState || _.noop;

        this.state = {
            inputAttr: '',
            validateOn: (this.props.validation && this.props.validation.validateOn) || '',
            value: this.props.value,
            formSubmitted: false
        };

        this.handleBlur = (event) => {
            let value = event.target.value,
                isInputError = false,
                validateOn = this.state.validateOn;

            this.hasBlurFired = event.type === 'blur';
            this.updateValueState(this.props.name, value);

            if (this.shouldValidateOnBlur(validateOn)) {
                isInputError = this.handleValidation(value, event);
                this.updateErrorState(isInputError);
            }

            if (this.props.handleBlur) {
                this.props.handleBlur(value, isInputError);
            }
        };

        this.handleChange = (event) => {
            let value = event.target.value,
                isInputError = false,
                validateOn = this.state.validateOn;

            // if function to update value state on parent component exists, set the value state in parent component
            if (this.updateValueState) {
                this.updateValueState(this.props.name, value);
            } else {
                this.setState({value});
            }

            if (Array.isArray(validateOn) && _.indexOf(validateOn, 'keyup') !== -1 && _.indexOf(validateOn, 'blur') !== -1) {
                // validation onChange will only happen if 'blur' has been included in the validateOn prop to check on
                // and the event fired, or if the form has been submitted
                if (_.indexOf(validateOn, 'submit') === -1 && (this.hasBlurFired || this.state.formSubmitted)) {
                    isInputError = this.handleValidation(value, event);
                    this.updateErrorState(isInputError);
                }
            } else if (this.shouldValidateOnKeyup(validateOn)) {
                isInputError = this.handleValidation(value, event);
                this.updateErrorState(isInputError);
            }

            if (this.props.handleChange) {
                this.props.handleChange(value, isInputError);
            }
        };

        this.handleValidation = (value, event) => {
            let validationResult;

            if (this.props.validation.validationRegex && this.props.validation.checkValidity) {
                throw new Error('Not allowed - can only provide one prop, either validationRegex or checkValidity()');
            }

            if (_.get(this.props, 'validation.checkValidity')) {
                validationResult = this.props.validation.checkValidity(value, this.state.formSubmitted, event);
                validationResult = typeof validationResult === 'object' ? validationResult : {isValid: validationResult};
                this.setState({inputAttr: validationResult.inputAttr});
                return !validationResult.isValid;
            } else {
                validationResult = {
                    isValid: this.props.validation.validationRegex.test(value)
                };
                this.setState({inputAttr: !validationResult.inputAttr});
                return !validationResult.isValid;
            }
        };

        this.getErrorMessage = () => {
            let validateOn = this.state.validateOn;

            // Displaying error message only if input will be validated on submit or form has already been submitted
            if (validateOn !== 'submit' || _.indexOf(validateOn, 'submit') === -1) {
                if (this.props.validationError) {
                    if (typeof this.state.inputAttr === 'object' && Object.keys(this.state.inputAttr)[0] === 'pattern') {
                        let pattern = _.get(this.props, 'validation.message.pattern', false);
                        return pattern && pattern[this.state.inputAttr.pattern];
                    }

                    switch (this.state.inputAttr) {
                        case 'required':
                            return _.get(this.props, 'validation.message.required', false);
                        case 'minlength':
                            return _.get(this.props, 'validation.message.minlength', false);
                        case 'maxlength':
                            return _.get(this.props, 'validation.message.maxlength', false);
                        case 'pattern':
                            return _.get(this.props, 'validation.message.pattern', false);
                        default:
                            return _.get(this.props, 'validation.message.default', false) || '';
                    }
                }
            }
        };

        this.shouldValidateOnBlur = (validateOn) => {
            return validateOn === 'blur' || _.indexOf(validateOn, 'blur') !== -1 && (validateOn !== 'submit' || _.indexOf(validateOn, 'submit') === -1);
        };

        this.shouldValidateOnKeyup = (validateOn) => {
            return validateOn === 'keyup' || _.indexOf(validateOn, 'keyup') !== -1 && (validateOn !== 'submit' || _.indexOf(validateOn, 'submit') === -1);
        };
    }
    
    inputRef = React.createRef();

    handleSubmit(formEle, input, value) {
        let {validation} = this.props;

        formEle.off('submit.inputField');
        formEle.on('submit.inputField', (evt) => {
            let validateOn = this.state.validateOn,
                isInputInvalid = false,
                didErrorPropUpdate;

            // On initial form submit, removing submit as the only event to validate on
            if (validateOn === 'submit') {
                this.setState({validateOn: ''})
            } else if (_.indexOf(validateOn, 'submit') !== -1) {
                validateOn.splice(_.indexOf(validateOn, 'submit'), 1);
                this.setState({validateOn: validateOn})
            }

            if (_.get(validation, 'checkValidity')) {
                let validationResult = validation.checkValidity(value, true, evt);
                isInputInvalid = typeof validationResult === 'object' && !validationResult.isValid;
                didErrorPropUpdate = this.props.validationError !== isInputInvalid;
                this.updateErrorState(isInputInvalid);
                this.setState({
                    formSubmitted: true
                });
            } else if (validation.validationRegex) {
                isInputInvalid = !(validation.validationRegex.test(value));
                didErrorPropUpdate = this.props.validationError !== isInputInvalid;
                this.updateErrorState(isInputInvalid);
                this.setState({
                    formSubmitted: true
                });
            }

            // If there happens to be a change in the input error state after submission and an onChange handler was
            // passed in as a prop, call the handler from props
            if (didErrorPropUpdate && this.props.handleChange) {
                this.props.handleChange(value, isInputInvalid);
            }

            if (isInputInvalid) {
                setTimeout(() => {
                    $(input).focus();
                }, 0);
            }
        })
    }

    render() {
        let {id, name, type, value, placeholder, disabled, validationError, autocomplete = "on", addon = false} = this.props;

        this.classNameInput = classNames({
            'sprk-b-TextInput': true,
            'sprk-u-Width-100': true,
            ...this.props.classNames
        });

        this.classNameWrapper = classNames({
            'has-error': validationError,
            'input-group': this.props.addon ? true : false
        });

        const errorMessage = this.getErrorMessage();

        return (
            <div>
                <InputContainer
                    error={validationError?errorMessage:null}
                    id={id}
                    label={placeholder}
                    inputRef={this.inputRef}
                    data-sprk-required-only='text'
                >
                    <input
                        ref={(input) => {
                            // Validating text input on submission of innermost parent form element
                            let formEle = $(input).closest('form');

                            if (formEle.length) {
                                this.handleSubmit(formEle, input, value);
                            }
                        }}
                        type={type}
                        value={value || this.state.value}
                        className={this.classNameInput}
                        id={id}
                        name={name}
                        onChange={(event) => this.handleChange(event)}
                        onBlur={(event) => this.handleBlur(event)}
                        disabled={disabled}
                        autoComplete={autocomplete}
                    />                    
                </InputContainer>
            </div>

        );
    }
}

InputFieldDeprecated.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    classNames: PropTypes.object,
    placeholder: PropTypes.string.isRequired,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    disabled: PropTypes.bool,
    updateErrorState: PropTypes.func,
    updateValueState: PropTypes.func,
    validation: PropTypes.shape({
        validateOn: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array
        ]),
        validationRegex: PropTypes.regexp,
        checkValidity: PropTypes.func,
        message: PropTypes.shape({
            default: PropTypes.string,
            required: PropTypes.string,
            pattern: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.array,
                PropTypes.object
            ]),
            minlength: PropTypes.string,
            maxlength: PropTypes.string
        })
    }).isRequired,
    validationError: PropTypes.bool,
    addon: PropTypes.string,
    autocomplete: PropTypes.string
};


export default InputFieldDeprecated;
